import request from "@utils/request";
import url from "@utils/url";

const { HOST } = url;

export async function getQRcode(params) {
  const url = `${HOST}/cps-gateway/api/v1/promotion/qrcode`;
  return request({ method: "get", url: url, responseType: "blob" }, params);
}

export async function getUrlLink(params) {
  const url = `${HOST}/cps-gateway/api/v1/promotion/urllink`;
  return request({ method: "get", url: url }, params);
}
